export type AppTheme = 'porta' | 'portaNZ' | 'redRec' | 'easycraft';

const namespace = process.env.NEXT_PUBLIC_NAMESPACE;

export const theme: AppTheme =
  namespace === 'porta' || namespace === 'portaNZ' || namespace === 'redRec' || namespace === 'easycraft'
    ? namespace
    : 'porta';
